import { styled } from '@linaria/react';

import Chunk from '@/components/Chunk';

import FinalButton from './FinalButton';

function IntroDemo({ stage = 'final' }) {
  const Wrapper = stage === 'shadow' ? WhiteWrapper : Chunk;

  return (
    <Wrapper>
      <FinalButton stage={stage}>Push Me</FinalButton>
    </Wrapper>
  );
}

const WhiteWrapper = styled.div`
  display: flex;
  justify-content: center;
  background: white;
  border-radius: 8px;
  padding: 48px;
  width: max-content;
  margin: 0 auto;
  margin-bottom: 48px;
`;

export default IntroDemo;
